module.exports = __webpack_public_path__ + "img/author-5.35433ac.jpg";